import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Routes, Route, HashRouter } from "react-router-dom";

import routes from './routes';

const App = () => {
  const queryClient = new QueryClient()

  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          {routes.map((route, i) => (
            <Route
              key={i}
              path={route.path}
              exact={route.exact}
              element={<route.component/> }
            />
          ))}
        </Routes>
      </HashRouter>
    </QueryClientProvider>
  );
}

export default App;
